export const sortStringsAphabetically = (strings: string[]): string[] => {
  if (!strings) {
    return [];
  }

  return [...strings].sort((a, b) => a.toString().localeCompare(b.toString()));
};
